var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5H16C16.3883 0.5 16.767 0.663375 17.0508 0.963867C17.3353 1.26521 17.4999 1.6795 17.5 2.11719V12.7061C17.5 13.1439 17.3355 13.5589 17.0508 13.8604C16.767 14.1607 16.3882 14.3232 16 14.3232H11.7842L11.6367 14.4805L9 17.2715L6.36328 14.4805L6.21582 14.3232H2C1.61177 14.3232 1.233 14.1607 0.949219 13.8604C0.664541 13.5589 0.500043 13.1439 0.5 12.7061V2.11719C0.500115 1.6795 0.664721 1.26521 0.949219 0.963867C1.23302 0.663375 1.6117 0.5 2 0.5Z",
    stroke: "#606060"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 11,
    height: 11,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10H17",
    stroke: "#606060",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanOutlined);
export default __webpack_public_path__ + "static/media/plan_outlined.bc7573e14afd3ba6eddb50e5895f4ec2.svg";
export { ForwardRef as ReactComponent };